import React from 'react'
import { View, Text } from '@react-pdf/renderer'
import { styles } from '../styles'
import { PDFHeaderProps } from '../types'

export function PDFHeader({ title, date, compact = false }: PDFHeaderProps) {
  if (compact) {
    return (
      <View style={styles.headerCompact}>
        <Text style={styles.runTitleCompact}>{title}</Text>
        {date && (
          <Text style={styles.runDateCompact}>
            {new Date(date).toLocaleDateString()}
          </Text>
        )}
      </View>
    )
  }
  
  return (
    <View style={styles.header}>
      <View>
        <Text style={styles.logo}>UltraPlan</Text>
      </View>
      <View>
        <Text style={styles.runTitle}>{title}</Text>
        {date && (
          <Text style={styles.runDate}>
            {new Date(date).toLocaleDateString()}
          </Text>
        )}
      </View>
    </View>
  )
}